<template>
  <div id="ylAboutHonorAward">
    <ylAboutHonorAwardMobile v-if="isMobileScreen" v-bind="$attrs" />
    <ylAboutHonorAwardPC v-else v-bind="$attrs" />
  </div>
</template>
<script>
export default {
  name: "ylAboutHonorAward",
  components: {
    ylAboutHonorAwardMobile: () => import("./components/mobile.vue"),
    ylAboutHonorAwardPC: () => import("./components/pc.vue"),
  },
  data() {
    return {};
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() { },
  methods: {},
};
</script>